// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { createContext, useContext, useMemo } from 'react';
import { SlotDiv } from '../utility/SlotDiv.js';
function isResponsive(value) {
    return typeof value === 'object';
}
function hasDefault(value, val) {
    return value === val || (isResponsive(value) && value.default === val);
}
export function Box(_a) {
    var { className, items: itemsSolo, justify: justifySolo, layout: align, gap = 'none', wrap, p = 'none', d = 'row', direction = d, container, style: userStyle, surface, theme, border, full, overflow, col, ref } = _a, rest = __rest(_a, ["className", "items", "justify", "layout", "gap", "wrap", "p", "d", "direction", "container", "style", "surface", "theme", "border", "full", "overflow", "col", "ref"]);
    const { spacingScale } = useContext(BoxContext);
    const style = useMemo(() => (Object.assign(Object.assign({}, userStyle), { '--spacing-scale': container === 'reset' ? 1 : spacingScale, '--local-corner-scale': container === 'reset' ? 1 : `${spacingScale}` })), [userStyle, spacingScale, container]);
    const items = itemsSolo !== null && itemsSolo !== void 0 ? itemsSolo : align === null || align === void 0 ? void 0 : align.split(' ')[0];
    const justify = justifySolo !== null && justifySolo !== void 0 ? justifySolo : align === null || align === void 0 ? void 0 : align.split(' ')[1];
    const main = (_jsx(SlotDiv, Object.assign({ ref: ref }, rest, { style: style, className: clsx('layer-components:flex layer-components:relative', {
            'layer-components:flex-row': hasDefault(direction, 'row'),
            'layer-components:flex-col': hasDefault(direction, 'col') || col,
            'layer-components:flex-row-reverse': hasDefault(direction, 'row-reverse'),
            'layer-components:flex-col-reverse': hasDefault(direction, 'col-reverse'),
            'layer-components:sm:flex-row': isResponsive(direction) && direction.sm === 'row',
            'layer-components:sm:flex-col': isResponsive(direction) && direction.sm === 'col',
            'layer-components:sm:flex-row-reverse': isResponsive(direction) && direction.sm === 'row-reverse',
            'layer-components:sm:flex-col-reverse': isResponsive(direction) && direction.sm === 'col-reverse',
            'layer-components:md:flex-row': isResponsive(direction) && direction.md === 'row',
            'layer-components:md:flex-col': isResponsive(direction) && direction.md === 'col',
            'layer-components:md:flex-row-reverse': isResponsive(direction) && direction.md === 'row-reverse',
            'layer-components:md:flex-col-reverse': isResponsive(direction) && direction.md === 'col-reverse',
            'layer-components:lg:flex-row': isResponsive(direction) && direction.lg === 'row',
            'layer-components:lg:flex-col': isResponsive(direction) && direction.lg === 'col',
            'layer-components:lg:flex-row-reverse': isResponsive(direction) && direction.lg === 'row-reverse',
            'layer-components:lg:flex-col-reverse': isResponsive(direction) && direction.lg === 'col-reverse',
            'layer-components:flex-wrap': hasDefault(wrap, true),
            'layer-components:sm:flex-wrap': isResponsive(wrap) && wrap.sm,
            'layer-components:md:flex-wrap': isResponsive(wrap) && wrap.md,
            'layer-components:lg:flex-wrap': isResponsive(wrap) && wrap.lg,
            'layer-components:gap-xs': gap === 'xs',
            'layer-components:gap-sm': gap === 'sm',
            'layer-components:gap-md': gap === 'md' || gap === true,
            'layer-components:gap-lg': gap === 'lg',
            'layer-components:gap-xl': gap === 'xl',
            'layer-components:items-center': items === 'center',
            'layer-components:items-stretch': items === 'stretch',
            'layer-components:items-start': items === 'start',
            'layer-components:items-end': items === 'end',
            'layer-components:justify-center': justify === 'center',
            'layer-components:justify-stretch': justify === 'stretch',
            'layer-components:justify-start': justify === 'start',
            'layer-components:justify-end': justify === 'end',
            'layer-components:justify-between': justify === 'between',
            'layer-components:justify-around': justify === 'around',
            'layer-components:p-xs': hasDefault(p, 'xs'),
            'layer-components:p-sm': hasDefault(p, 'sm'),
            'layer-components:p-md': hasDefault(p, 'md') || hasDefault(p, true),
            'layer-components:p-lg': hasDefault(p, 'lg'),
            'layer-components:p-xl': hasDefault(p, 'xl'),
            'layer-components:sm:p-xs': isResponsive(p) && p.sm === 'xs',
            'layer-components:sm:p-sm': isResponsive(p) && p.sm === 'sm',
            'layer-components:sm:p-md': isResponsive(p) && p.sm === 'md',
            'layer-components:sm:p-lg': isResponsive(p) && p.sm === 'lg',
            'layer-components:sm:p-xl': isResponsive(p) && p.sm === 'xl',
            'layer-components:md:p-xs': isResponsive(p) && p.md === 'xs',
            'layer-components:md:p-sm': isResponsive(p) && p.md === 'sm',
            'layer-components:md:p-md': isResponsive(p) && p.md === 'md',
            'layer-components:md:p-lg': isResponsive(p) && p.md === 'lg',
            'layer-components:md:p-xl': isResponsive(p) && p.md === 'xl',
            'layer-components:lg:p-xs': isResponsive(p) && p.lg === 'xs',
            'layer-components:lg:p-sm': isResponsive(p) && p.lg === 'sm',
            'layer-components:lg:p-md': isResponsive(p) && p.lg === 'md',
            'layer-components:lg:p-lg': isResponsive(p) && p.lg === 'lg',
            'layer-components:lg:p-xl': isResponsive(p) && p.lg === 'xl',
            'layer-components:rounded-lg': !!surface,
            'layer-components:bg-white layer-components:border-black': surface === true || surface === 'default',
            'layer-components:bg-wash layer-components:border-black': surface === 'wash',
            'layer-components:bg-primary-wash layer-components:border-primary-dark layer-components:color-primary-ink': surface === 'primary',
            'layer-components:bg-accent-wash layer-components:border-accent-dark layer-components:color-accent-ink': surface === 'accent',
            'layer-components:bg-attention-wash layer-components:border-attention-dark layer-components:color-attention-ink': surface === 'attention',
            'layer-components:border layer-components:border-solid layer-components:rounded-lg': border,
            'layer-components:w-full': full === true || full === 'width',
            'layer-components:h-full': full === true || full === 'height',
            'layer-components:overflow-hidden': overflow === 'hidden',
            'layer-components:overflow-auto': overflow === 'auto',
            'layer-components:overflow-x-auto layer-components:overflow-y-hidden': overflow === 'auto-x',
            'layer-components:overflow-y-auto layer-components:overflow-x-hidden': overflow === 'auto-y',
        }, theme && `theme-${theme}`, className) })));
    if (container || p) {
        return (_jsx(BoxContext.Provider, { value: {
                spacingScale: container === 'reset'
                    ? 1
                    : spacingScale * SPACING_SCALE_NESTING_FACTOR,
            }, children: main }));
    }
    return main;
}
const SPACING_SCALE_NESTING_FACTOR = 0.75;
export const BoxContext = createContext({
    spacingScale: 1,
});
//# sourceMappingURL=Box.js.map